import React from "react";
import {
    Column,
    DataGrid,
    Paging,
    Pager,
    HeaderFilter,
    FilterRow,
    FormItem,
    Lookup,
} from 'devextreme-react/data-grid';
import { Format } from "devextreme-react/number-box";
import { Editing } from "devextreme-react/scheduler";
import PaginaToolbar from '../components/PaginaToolbar';
import { criarMotivoIsencaoIptuDs, criarCadastrarLeisDs } from "../DataSources";
import UserInfo from "../UserInfo";
import uiInfo from "../ui-info";

export default class MotivoIsensaoIptuBox extends React.Component {
    constructor() {
        super();
        this.initNewRow = this.initNewRow.bind(this);

        this.tipoOptions = {
            editorType: "dxSelectBox",
            searchEnabled: false,
            dataSource: [
                { id: 0, descricao: "NÃO INFORMADO" },
                { id: 1, descricao: "ISENCAO DE IPTU" },
                { id: 2, descricao: "SITUAÇÃO DE LANÇAMENTO" },
                { id: 3, descricao: "CANCELAMENTO DIAT" },
                { id: 4, descricao: "REMISSÃO DIAT" },
                { id: 5, descricao: "ISENÇÃO DIAT" },
                { id: 6, descricao: "POSIÇÃO FISCAL DO IMÓVEL" },
            ],
            valueExpr: "id",
            displayExpr: "descricao"
        };
    }

    render() {
        return (
            <div className={'content-block dx-card responsive-paddings'}>
                <PaginaToolbar titulo="Cadastro de Motivos">
                    <DataGrid
                        dataSource={criarMotivoIsencaoIptuDs()}
                        showBorders={true}
                        rowAlternationEnabled={true}
                        remoteOperations={true}
                        focusedRowEnabled={true}
                        wordWrapEnabled={true}
                        onInitNewRow={this.initNewRow} >
                        <HeaderFilter visible={true} />
                        <FilterRow visible={true} />
                        <Editing mode={"row"} allowAdding={false} allowUpdating={true} allowDeleting={true} useIcons={true} />
                        <Column type={"buttons"}  fixed={true} fixedPosition={"left"} />
                        <Column dataField={'id'} caption={"ID"} width={80} allowEditing={false} alignment={'left'} visible={false}/>
                        <Column dataField={'sequencial'} caption={"#"} width={100} allowEditing={false} alignment={'center'} />
                        <Column dataField={'prefeituraId'} caption={"Prefeitura"} visible={false}>
                            <FormItem visible={false}></FormItem>
                        </Column>
                        <Column dataField={'descricao'} caption={"Descrição"} />
                        <Column dataField={'leiId'} caption={"Lei"} dataType='number'>
                            <Lookup
                                dataSource={criarCadastrarLeisDs}
                                valueExpr={"id"}
                                displayExpr={"descricao"}
                            />
                        </Column>
                        <Column dataField={'baseLegal'} caption={"Base Legal"} />
                        <Column dataField={'tipo'} caption={"Tipo"} editorType={"dxSelectBox"} editorOptions={this.tipoOptions}>
                            <Lookup
                                dataSource={this.tipoOptions.dataSource}
                                valueExpr={"id"}
                                displayExpr={"descricao"}
                            />
                        </Column>
                        <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />
                        <Pager
                            showPageSizeSelector={true}
                            allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
                        />
                    </DataGrid>
                </PaginaToolbar>
            </div>
        );
    }

    initNewRow(e) {
        e.data.prefeituraId = UserInfo.getPrefeitura();
    }

}
